import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import strings from "../../config/localization";
import {
  useModifyUserMutation,
  useGetOrganizationsQuery,
} from "../../services/appln";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Formik, Form, FormikErrors } from "formik";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import EditButton from "../../components/Buttons/EditButton";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Autocomplete from "@mui/material/Autocomplete";

interface FormData {
  name: string;
  organizationId: string;
}

interface Props {
  title: string;
  userId: string;
  initialValues: any;
}

export default function EditUserDialog({
  title,
  userId,
  initialValues,
}: Props) {
  console.log("initial values", initialValues);

  const orgQueryResponse = useGetOrganizationsQuery("");
  const orgMap = new Map<string, string>();
  orgQueryResponse.data?.data.forEach((element: any) => {
    orgMap.set(element.name, element.id);
  });

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [modifyUser, modifyUserParams] = useModifyUserMutation();

  const iv: FormData = {
    name: initialValues.row.fullName,
    organizationId: initialValues.row.organizationName,
  };

  if (modifyUserParams.isLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (modifyUserParams.isUninitialized || modifyUserParams.isSuccess) {
    // trigger not called yet, show form
    return (
      <div>
        <EditButton onClickHandler={handleClickOpen} />
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title"> {title} </DialogTitle>
          <DialogContent>
            <Formik
              initialValues={iv}
              validate={(values) => {
                const errors: FormikErrors<FormData> = {};
                if (!values.name) {
                  errors.name = strings.nameMandatory;
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                handleClose();
                values.organizationId = orgMap.get(values.organizationId!)!;
                modifyUser({
                  values,
                  userId: userId,
                });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => (
                <Form>
                  <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          required
                          margin="normal"
                          id="name"
                          name="name"
                          label={strings.name}
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.name && Boolean(errors.name)}
                          helperText={touched.name && errors.name}
                          InputLabelProps={{ shrink: true }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Autocomplete
                          fullWidth
                          disablePortal
                          id="organizationId"
                          value={values.organizationId}
                          options={Array.from(orgMap.keys())}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={strings.organization}
                            />
                          )}
                          onChange={(e, value: any) => {
                            console.log(value);
                            setFieldValue("organizationId", value);
                          }}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.save}
                        </Button>
                      </Grid>
                      <Grid item xs={3}>
                        <Button variant="contained" onClick={handleClose}>
                          {strings.cancel}
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  // // should never be here..
  return <h1>wierd state !</h1>;
}
